import { ActionEndpointService } from "@/views/reminder/shared/endpoint_services/action-endpoint-service"
import { UserAction } from "@/views/reminder/models/action.model"

export class ActionService {
    constructor () {
        this.actionEndpointService = new ActionEndpointService()
    }

    async getAll (clientId, userId) {
        const userActions = await this.actionEndpointService.getAll(clientId, userId)
        return userActions.map(ua => { return { action: ua.action.toString(), interval: ua.interval } })
    }

    async save (clientId, clientNumber, userId, userNumber, allActions) {
        const userActions = allActions.map(action => {
            const userAction = new UserAction()
            userAction.clientId = clientId
            userAction.clientNumber = clientNumber
            userAction.userId = userId
            userAction.userNumber = userNumber || '0'
            userAction.action = +action.action
            userAction.interval = +action.interval
            return userAction
        })
        console.log('userActions', userActions)
        await this.actionEndpointService.save(clientId, userId, userActions)
    }
}
